import { omit } from 'lodash';
import { type IFramework } from '@/framework';
import { type ILayerProps } from '@/version-types';
import { Events } from '../constants';
import { type SVGPreviewRequest } from '../types';

/**
 * 更新舞台中的目标图层
 * @param framework - 框架实例
 * @param layer - 图层
 * @param options - 更新选项；dataOnly 为 true 时只写数据，不触发正式 drawable 构建。
 * @returns 无返回值。
 */
export const updateLayer = (framework: IFramework, layer: ILayerProps, options: { dataOnly?: boolean } = {}): void => {
    framework.service.frame.addOrUpdateLayer(layer, undefined, options.dataOnly);
    framework.service.frame.setActiveLayer(layer.id);
};

/**
 * 向可选的 Vector SVG preview 插件发送连续交互通知。
 *
 * API 不需要感知插件是否注册或是否成功接管。各阶段语义定义在 `SVGPreviewRequest.phase`。
 *
 * @param framework - 当前框架实例。
 * @param phase - 预览阶段。
 * @param layer - 本次需要更新或提交的图层。
 * @returns 无返回值。
 */
export const requestVectorSVGPreview = (
    framework: IFramework,
    phase: SVGPreviewRequest['phase'],
    layer: ILayerProps,
): void => {
    const request: SVGPreviewRequest = {
        phase,
        layer,
    };

    framework.service.events.emit(Events.SVGPreviewRequest, request);
};

/**
 * 写入历史记录
 * @param framework - 框架实例
 * @param prevLayer - 更新前的图层
 * @param nextLayer - 更新后的图层
 * @param funcID - 功能 ID，主要用于埋点统计
 * @returns 无返回值。
 */
export const pushHistory = (
    framework: IFramework,
    prevLayer: ILayerProps,
    nextLayer: ILayerProps,
    funcID?: string,
): void => {
    const prev = omit(prevLayer, '__isOnTextEditing');
    const next = omit(nextLayer, '__isOnTextEditing');
    framework.service.history.write(prev, next, funcID);
};
